import { userDataType } from "../../../stores/accountManagementStore";
import { toast } from "react-toastify";
import { supabase } from "../../../context/useSupabaseContext";

export default async function signInWithTokens(
    access_token: string,
    refresh_token: string
): Promise<userDataType | null> {
    try {
        // After OAuth redirect, Supabase should have already set the session
        // We just need to get the current session
        const { data: sessionData, error: sessionError } = await supabase.auth.getSession();

        if (sessionError) {
            throw sessionError;
        }

        if (!sessionData.session) {
            // If no session exists, try to set it with the provided tokens
            const { data: setData, error: setError } = await supabase.auth.setSession({
                access_token,
                refresh_token,
            });

            if (setError) {
                throw setError;
            }

            if (!setData.user || !setData.session) {
                throw new Error('Failed to set session');
            }

            // Transform to userDataType
            const userData: userDataType = {
                id: setData.user.id,
                email: setData.user.email || '',
                providers: setData.user.app_metadata?.providers || ['google']
            };

            return userData;
        }

        // Session exists, transform to userDataType
        const userData: userDataType = {
            id: sessionData.session.user.id,
            email: sessionData.session.user.email || '',
            providers: sessionData.session.user.app_metadata?.providers || ['google'],
            // tokens: {
            //     accessToken: sessionData.session.access_token,
            //     refreshToken: sessionData.session.refresh_token,
            // },
        };

        return userData;
    } catch (err) {
        console.log("Token sign-in error:", err);
        toast.error("Failed to sign in with tokens");
        return null;
    }
}
